module.exports = __webpack_public_path__ + "static/media/IMG_4255.c143f709.JPG";